import DebouncedSearchInputFilter from '../filters/DebouncedSearchInputFilter';
import MyTeamFiltersWrapper from '../filters/MyTeamFiltersWrapper';
import { Box } from 'foundations-components/transitional/components/Box';
import { TeamsFilterButton, TeamMemberFilterButton, PlaylistsFilterButton } from '../filters/Filters';
import { useIsAnyFilterSet } from '../../hooks/filtersHooks';
import { useCallback } from 'react';
import UsageTracker from '../../../../utils/UsageTracker';
import I18n from 'I18n';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistsTableFilters = ({
  store
}) => {
  const {
    state: {
      search,
      teams,
      users,
      assignedByMe,
      playlists
    },
    actions: {
      setSearch,
      resetTableState,
      setTeams,
      setUsers,
      setAssignedByMe,
      setPlaylists
    }
  } = store;
  const isAnyFilterSet = useIsAnyFilterSet(store, ['teams', 'users', 'playlists', 'assignedByMe']);
  const handleSearchChange = useCallback(newSearch => {
    setSearch(newSearch);
    if (newSearch) {
      UsageTracker.track('teamInteraction', {
        action: 'search-input',
        value: newSearch
      });
    }
  }, [setSearch]);
  return /*#__PURE__*/_jsx(MyTeamFiltersWrapper, {
    isAnyFilterSet: isAnyFilterSet,
    onClearAllFilters: resetTableState,
    searchInput: /*#__PURE__*/_jsx(DebouncedSearchInputFilter, {
      onChange: handleSearchChange,
      placeholder: I18n.text('learningCenter.myTeam.filters.search.searchByPlaylistName'),
      value: search
    }),
    showActionsMenu: false,
    showFilterByLabel: true,
    tableStore: store,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      marginInlineEnd: "600",
      children: [/*#__PURE__*/_jsxs(Box, {
        alignItems: "center",
        marginInlineStart: "100",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "assignedByMeToggle",
          paddingBlock: "0",
          paddingInlineEnd: "100",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.filters.assignedByMe"
            })
          })
        }), /*#__PURE__*/_jsx(Toggle, {
          checked: assignedByMe === true,
          id: "assignedByMeToggle",
          label: I18n.text('learningCenter.myTeam.filters.assignedByMe'),
          marginInlineStart: "300",
          onChange: ({
            target: {
              checked
            }
          }) => {
            setAssignedByMe(checked ? true : undefined);
          },
          size: "extra-small"
        })]
      }), /*#__PURE__*/_jsx(Box, {
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(View, {
          blockSize: "20px",
          borderColor: "border-core-subtle",
          borderInlineEndStyle: "solid",
          borderInlineEndWidth: "200",
          marginInlineEnd: "100",
          marginInlineStart: "400"
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(TeamsFilterButton, {
          setTeams: setTeams,
          teams: teams
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(TeamMemberFilterButton, {
          setUsers: setUsers,
          users: users
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(PlaylistsFilterButton, {
          playlists: playlists,
          setPlaylists: setPlaylists
        })
      })]
    })
  });
};
export default PlaylistsTableFilters;